import { inject } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { updateSearch } from 'bernie-core';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { ILocalization, useLocalization } from '@shared-ui/localization-context';
import { LineOfBusinessDomain, OneKeyBanner, OneKeyBannerInputs, PageLocation } from '@shared-ui/retail-loyalty-one-key-banner';

import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { packageTypeMap } from 'stores/adapters';
import { SearchResultsStore } from 'src/common/stores/search-results-store';

import { Level, liveAnnounce } from 'uitk-react-utils';
import { UitkSpacing } from 'uitk-react-spacing';

import { History, Location } from 'history';

export interface LoyaltyMessagingProps {
  searchResults?: SearchResultsStore;
  multiItem?: MultiItemStore;
}

const handleClick = (history: History, location: Location, l10n: ILocalization) => (isChecked: boolean) => {
  updateSearch({ history, location, newParams: { useRewards: String(isChecked) }, replace: true });

  if (isChecked) {
    setTimeout(() => liveAnnounce(l10n.formatText('common.pointsRemoved'), Level.POLITE), 500);
  } else {
    setTimeout(() => liveAnnounce(l10n.formatText('common.pointsApplied'), Level.POLITE), 500);
  }
};

export const OneKeyBannerToggle: React.FC<LoyaltyMessagingProps> = inject(
  'searchResults',
  'multiItem'
)(
  React.memo(({ searchResults, multiItem }: LoyaltyMessagingProps) => {
    const history = useHistory();
    const location = useLocation();
    const l10n = useLocalization();
    const searchCriteria = searchResults?.searchCriteria;

    if (!searchCriteria) return null;

    const getLineOfBusinessDomain = () =>
      multiItem?.isPackageShoppingPath() ? LineOfBusinessDomain.PACKAGES : LineOfBusinessDomain.LODGING;
    const experimentName = multiItem?.isPackageShoppingPath() ? 'TSDP_OneKey_Anon_HSRFSRCSR_Web' : 'one_key_lodging_offers';
    const packageType = multiItem?.getPackageType();
    const inputs: OneKeyBannerInputs = {
      useLoyaltyCurrency: searchCriteria.useRewards === 'true',
      pageLocation: PageLocation.SEARCH_RESULTS,
      lineOfBusiness: getLineOfBusinessDomain(),
      packageType: packageType && packageTypeMap[packageType],
    };

    return (
      <Experiment name={experimentName}>
        <ExperimentControl />
        <ExperimentVariant bucket={1}>
          <UitkSpacing padding={{ blockstart: 'two' }}>
            <div data-stid="onekeybanner-toggle">
              <OneKeyBanner inputs={inputs} switchHandler={handleClick(history, location, l10n)} showBorder={false} skipSsr />
            </div>
          </UitkSpacing>
        </ExperimentVariant>
      </Experiment>
    );
  })
);

OneKeyBannerToggle.displayName = 'OneKeyBannerToggle';
